

















import _ from 'lodash'
import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator'
import {VColorPickerColor} from '@/types'
import parse from 'parse-color';

/**
 * Campo para seleccionar color
 *
 * Pinta en la interfaz un campo de texto, cuando el usuario hace click sobre
 * el se mostrara un selector de color.
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component
export default class ColorPickerField extends Vue {
    /**
     * Etiqueta del input
     *
     * @var { string }
     */
    @Prop({type: String, default: 'Selecciona un color'})
    public label: string

    /**
     * Tiempo de espera para actualizar el valor del color
     */
    @Prop({type: Number, default: 0})
    public debounce: number

    /**
     * Permite al componente padre definir el color que será mostrado
     * en el selector. Puede ser un
     */
    @Prop({type: [String, Object], default: null})
    public value: string | VColorPickerColor

    /**
     * Si esta opción se encuentra activa el evento "input" retornará
     * el objeto completo con todos los formatos de color.
     *
     * Al estar desactivada el componente retornará un string
     * con el formato en rgba
     *
     * @var { boolean }
     */
    @Prop({type: Boolean, default: false})
    public returnObject: boolean

    /**
     * Color seleccionado por el usuario
     */
    public color: Partial<VColorPickerColor> | null = null

    /**
     * Retorna el color en formato CSS RGBA adecuado
     */
    public get formattedColor () {
        if (!this.color || !this.color.rgba) {
            return null
        }

        const { r, g, b, a } = this.color.rgba

        return `rgba(${r}, ${g}, ${b}, ${a})`
    }

    /**
     * Observa el valor introducido por el componente padre
     */
    @Watch('value', {immediate: true})
    public watchValue (value: string | VColorPickerColor) {
        // El valor es nulo o falso
        if (!value) {
            return this.color = null
        }

        if (_.isObject(value)) {
            this.color = value

            return
        }

        const result = parse(value)
        // Si el resultado es falso el formato introducido no es válido
        // y no puede ser procesado
        if (!result) {
            return
        }

        const [r, g, b, a] = result.rgba
        this.color = { rgba: {r, g, b, a} }
    }

    /**
     * Función para actualizar el color
     *
     * Retorna una función encargada de notificar al componente padre que el usuario
     * ha seleccionado un color.
     *
     * Si la propiedad "debounce" del componente se encuentra definida el getter
     * retornará un función con retardo de acción.
     */
    public get updateColor () {
        const update = (color: VColorPickerColor) => {
            this.color = color
            this.$emit('input', this.returnObject ? color : this.formattedColor)
        }

        return this.debounce
            ? _.debounce(update, this.debounce)
            : update
    }
}
